import React, { useState, useCallback, useEffect } from 'react'
import { useDebounce } from 'use-debounce'
import { TextField, Popover, ColorPicker, Button, Stack, rgbToHsb, rgbString, hsbToRgb } from '@shopify/polaris'
import hexToRgb from 'hex-rgb'

const getHsbaColor = (color) => {
  if (!color) return
  const rgbaValues = color.replace(/[^\d*.?\d*,]/g, '').split(',')
  const rgbColor = {
    red: rgbaValues[0],
    green: rgbaValues[1],
    blue: rgbaValues[2]
  }
  const hsbColor = typeof color === 'string'
    ? rgbToHsb(rgbColor)
    : rgbToHsb(color)
  hsbColor.alpha = rgbaValues[3]
  return hsbColor
}

const ColorPickerInputComponent = (props) => {
  const [popoverActive, setPopoverActive] = useState(false)
    const initialValue = props.value ? (
      props.value &&
      props.value &&
      /^#[0-9A-F]{6}$/i.test(props.value)
    ) ? rgbString(hexToRgb(props.value))
      : props.value
    : 'rgba(0, 0, 0, 0)'
  const [inputValue, setInputValue] = useState(initialValue)
  const [inputValueDebounced] = useDebounce(inputValue, 300)

  useEffect(() => {
    if (props.onChange)
      props.onChange(props.name, inputValueDebounced)
  }, [inputValueDebounced])

  const handleColorChange = useCallback((color) => {
    const rgbaColor = rgbString(hsbToRgb(color))
    setInputValue(rgbaColor)
  }, [])

  const handlePopoverClose = useCallback(() => {
    setPopoverActive(false)
  }, [])

  const handlePopoverOpen = useCallback(() => {
    setPopoverActive(true)
  }, [])

  const hsbColor = getHsbaColor(inputValue)

  const activator = (
    <Button fullWidth={props.buttonFullWidth} textAlign='left' onClick={handlePopoverOpen}>
      <Stack alignment='center' spacing='tight'>
        <div
          style={{
            height: '2rem',
            width: '2rem',
            borderRadius: '0.3rem',
            background: inputValue,
            border: '1px solid rgb(223, 227, 232)'
          }}
        />
        <span>{props.label}</span>
      </Stack>
    </Button>
  )

  return (
    <Popover
      active={popoverActive}
      activator={activator}
      onClose={handlePopoverClose}
    >
      <Popover.Section>
        <ColorPicker
          onChange={handleColorChange}
          color={hsbColor}
          allowAlpha
        />
      </Popover.Section>
      <Popover.Section>
        <TextField value={inputValue} readOnly />
      </Popover.Section>
    </Popover>
  )
}

export default ColorPickerInputComponent
